
import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {
  // Handle undefined or null values gracefully
  const progressValue = typeof value === 'number' ? value : 0;
  
  // Log the progress value for debugging
  React.useEffect(() => {
    console.log(`Progress component value: ${progressValue}%`);
  }, [progressValue]);
  
  // Simplified color logic - green for completed, purple gradient for in progress
  // Ensure 100% is shown as green
  const getProgressColor = () => {
    if (progressValue >= 100) return "bg-green-500";
    if (progressValue >= 50) return "bg-indigo-500";
    return "bg-[#9b87f5]";
  };
  
  // Simplified visual feedback without animations
  const barClasses = cn(
    "h-full w-full flex-1 transition-all",
    getProgressColor(),
    progressValue === 0 ? "opacity-40" : "opacity-100"
  );
  
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-[#F1F0FB]",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={barClasses}
        style={{ transform: `translateX(-${100 - progressValue}%)` }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
